
import { Component, Vue, Watch, Prop, Emit, Model } from "vue-property-decorator";
import OCROrderApi from "@/api/ocr-order-api";

import Config from "./config"
import { Toast } from "vant";
type MainType = Config.DetailItem
@Component({ name: "item-editor" })
export default class ItemEditor extends Vue {

    loading = 0;
    vShow = false;
    preview = true
    nextTimeHandler?: number
    edititem: MainType = {} as any

    @Prop({ required: true })
    item!: MainType

    @Model("update")
    visiable!: boolean

    get files() {
        if (!this.item) return [];
        const files = (this.item.files || []).map(e => e.url);
        return files;
    }

    @Watch("item")
    itemOnChnage(v: MainType) {
        if (!v) return;
        this.preview = true;
        this.edititem = { ...v }
        delete (this.edititem as any).files;
    }
    @Watch("visiable", { immediate: true })
    visiableOnChange() {
        if (this.visiable == this.vShow) return;
        this.vShow = this.visiable;
    }

    @Watch("vShow")
    @Watch("preview")
    vShowOnChanged(v: boolean) {
        if (this.vShow) this.$nextTick(this.pageOnResize);
        if (this.vShow != this.visiable) this.$emit("update", this.vShow);
    }

    created() {
        window.addEventListener("resize", this.pageOnResize);
    }
    mounted() {

    }
    beforeDestroy() {
        window.removeEventListener("resize", this.pageOnResize);
    }

    @Emit("swipe")
    swipe(v: number) {

        if (this.nextTimeHandler) return;
        clearInterval(this.nextTimeHandler)
        this.nextTimeHandler = undefined;
    }

    pageOnResize() {
        if (!this.$el.firstChild) return;
        const div = this.$el.getElementsByClassName("van-image-preview__swipe")[0] as HTMLDivElement;
        var editFrm = this.$el.getElementsByClassName("edit-part")[0];
        const h = document.documentElement.clientHeight - editFrm.clientHeight;
        div.style.height = `${h}px`;
    }

    doEdit(isEdit: boolean) {
        this.preview = !isEdit;
    }

    async setPass() {
        const message = this.checkFrm(true);
        if (message) return Toast({ message, icon: "fail" })
        console.error(message, this.edititem)
        await OCROrderApi.setPass(this.edititem.Id, this);
        this.edititem.CheckStatus = 1;
        this.item.CheckStatus = 1;
        this.passDone();
    }

    checkFrm(force = false) {
        if (!this.edititem.CheckStatus && !force) return;
        if (this.edititem.PhotoStatus) return "“照片”标记为“异常”时，不能勾选“标记为正确”"
        if (!this.edititem.PartNo) return "型号不能为空";
        if (!this.edititem.Brand) return "品牌不能为空";
        if (!this.edititem.RegionName) return "产地不能为空";
        return null
    }

    passDone() {
        if (!this.edititem.CheckStatus) return;
        Toast({ message: "物料标记成功，即将切到下一项", icon: "success" })
        this.nextTimeHandler = setTimeout(() => this.swipe(1), 1000);
    }


    photoStatusChnage(v: number) {
        //console.error("v",v);
        if (!v) return;
        if (this.files.length > 1) Toast({ message: `本物料有${this.files.length}张照片，左右划动切换照片` });
    }

    async onSubmit() {
        const msg = this.checkFrm();
        if (msg) return Toast({ message: msg, icon: "fail", duration: 8000 });
        const pararm = { ...this.edititem };
        pararm.CheckStatus = pararm.CheckStatus ? 1 : 0;
        await OCROrderApi.edit(pararm, this);
        Object.assign(this.item, this.edititem);
        this.preview = true;
        this.passDone();
    }

}
